import { Component, OnInit, ViewChild, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatStepper, MatStep, MatStepLabel } from '@angular/material/stepper';
import { EmployeeService } from 'src/app/services/employee.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-force-setup-do-not-disturb-shortcuts-dialog',
  templateUrl: './force-setup-do-not-disturb-shortcuts-dialog.component.html',
  styleUrl: './force-setup-do-not-disturb-shortcuts-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatStepper, MatStep, MatStepLabel, MatDialogActions, MatButton],
})
export class ForceSetupDoNotDisturbShortcutsDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<ForceSetupDoNotDisturbShortcutsDialogComponent>>(MatDialogRef);
  private employees = inject(EmployeeService);

  selectedIndex: number = 0;
  @ViewChild(MatStepper, { static: true }) stepper: MatStepper;

  ngOnInit(): void {}

  recheck() {
    this.employees.recheckToForceSetupDoNotDisturbShortcutsDialog();
  }

  next() {
    this.selectedIndex++;
    this.stepper.next();
  }

  previous() {
    this.selectedIndex--;
    this.stepper.previous();
  }
}
